import { request } from "./request.js";

export async function get(key) {
    return await request("/therapy-session", { key: key }, "POST");
}

export async function save(data) {
    return await request("/therapy-session/save", data, "POST");
}

export async function list(params = {}) {
    return await request("/therapy-session/list", params, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/session", data, "POST");
}
